import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsAllFetched, getIsFetching, getUtensils } from '../selectors';
import { fetchUtensils } from '../actions';

const useUtensils = () => {
  const [notStartedFetching, setNotStartedFetching] = useState(true);
  const dispatch = useDispatch();

  const isAllFetched = useSelector(getIsAllFetched);
  const utensils = useSelector(getUtensils).toJS();
  const isFetchingUtensils = useSelector(getIsFetching);

  let isFetching;
  if (isAllFetched) {
    isFetching = false;
  } else if (notStartedFetching) {
    isFetching = true;
  } else {
    isFetching = isFetchingUtensils;
  }

  useEffect(() => {
    if (!isAllFetched) {
      dispatch(fetchUtensils());
    }
    setNotStartedFetching(false);
  }, [dispatch, isAllFetched]);

  return [isFetching ? null : utensils, isFetching];
};

export default useUtensils;
